import { CSSProperties } from "react";

import { IFormStyles } from "./../../../store/forms/types";
import { ColorPickerModes } from "./../../../libs/Picker/types.d";

export const getFormBackgroundStyles = (styles: IFormStyles["background"]): CSSProperties => {
    const css: CSSProperties = {} as CSSProperties;

    if (styles) {
        const {
            color: { type, style },
        } = styles;

        switch (type) {
            case ColorPickerModes.SOLID:
                css.backgroundColor = style;
                break;
            case ColorPickerModes.GRADIENT:
                css.background = style;
                break;
            case ColorPickerModes.IMAGE:
                css.backgroundImage = `url(${style})`;
                css.backgroundRepeat = "no-repeat";
                css.backgroundPosition = "50% 50%";
                css.backgroundSize = "100% auto";
                break;
        }
    }

    return css;
};
